import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const Wrapper = styled.div`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  ${media.mediumUp`
    flex-direction: row;
  `}
`;

export const Sidebar = styled.div`
  min-width: 300px;
  max-width: 300px;
  ${media.smallOnly`
    max-width: 100%;
  `}
  padding: 0 10px;
`;

export const Main = styled.div``;

export const Header = styled.h1`
  font-size: 22px;
  margin: 20px 10px;
`;

export const ResultsHeader = styled.div`
  padding: 0px 10px;
`;
